import {
  Position,
  Toaster,
  Intent,
  IToastProps,
  IActionProps,
  ILinkProps,
  IconName,
  MaybeElement,
} from '@blueprintjs/core'
import { ApolloError } from 'apollo-boost'
import { get } from 'lodash'

const AppToaster = Toaster.create({
  position: Position.TOP_RIGHT,
})

function warning(config: IToastProps) {
  AppToaster.show({ intent: Intent.WARNING, icon: 'info-sign', ...config })
}

function success(config: IToastProps) {
  AppToaster.show({ intent: Intent.SUCCESS, icon: 'tick', ...config })
}

interface FailProps {
  error?: ApolloError
  message?: React.ReactNode
  action?: IActionProps & ILinkProps
  icon?: IconName | MaybeElement
  onDismiss?: (didTimeoutExpire: boolean) => void
  timeout?: number
}

function fail({ error, message, ...rest }: FailProps) {
  if (error && error.graphQLErrors && error.graphQLErrors.length) {
    for (const { message } of error.graphQLErrors) fail({ message, ...rest })
    return
  }

  message = message || get(error, 'message') || ''
  AppToaster.show({
    intent: Intent.DANGER,
    icon: 'warning-sign',
    message,
    ...rest,
  })
}

export default {
  success,
  fail,
  warning,
  dismissAll: () => {
    AppToaster.getToasts().forEach((t) => {
      if (t.key) {
        AppToaster.dismiss(t.key)
      }
    })
  },
}
